import { Observable, throwError, interval, concat, race } from 'rxjs';
import { tap, take, flatMap, switchMap, switchMapTo, catchError } from 'rxjs/operators';
import { clearModal$, createModal$ } from '@apiEnabler/api-enabler-common/lib/dialogs';
import { confirmLogOut$, notifyTokenExpiration$, extendSession$, renewSessionToken$ } from './intents';
import { flog } from '@zambezi/caballo-vivo';
import { doLogout$ } from './authorization';
import { createErrorWithType } from '@apiEnabler/api-enabler-common/lib/errors';
var logoutGraceTimeSeconds = 60;
var graceInterval$ = concat(interval(1000).pipe(take(logoutGraceTimeSeconds + 1), flatMap(function (i) {
  return createModal$('timeout.countdown', logoutGraceTimeSeconds - i);
})), doLogout$.pipe(catchError(function () {
  return throwError(createErrorWithType('Session expired!', 'token-expired'));
}), flog('timeout explicit logout')));
var modalRace$ = race(concat(confirmLogOut$, doLogout$.pipe(flog('modalRace - user said "logout"'))), extendSession$.pipe(switchMapTo(clearModal$), tap(renewSessionToken$), flog('modalRace - user said "refresh"')));
var sessionExpiryAlert$ = notifyTokenExpiration$.pipe(switchMap(function () {
  return createSwitcher$(graceInterval$, modalRace$).pipe(flog('Session token timeout reached'));
}));
function createSwitcher$(obs1, obs2) {
  return Observable.create(function (o) {
    var subscription1 = obs1.subscribe(function (x) {
      return o.next(x);
    }, function (e) {
      return o.error(e);
    }, function () {
      return o.complete();
    });
    var subscription2 = obs2.subscribe(function (x) {
      subscription1.unsubscribe();
      o.next(x);
    }, function (e) {
      return o.error(e);
    }, function () {
      return o.complete();
    });
    return function () {
      subscription1.unsubscribe();
      subscription2.unsubscribe();
    };
  });
}
export default sessionExpiryAlert$;